





























import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
@Component({})
export default class extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Object, default: {} }) data: any;
  form: any = {};
  Url = XMLHTTP_BASEURL;
  imageUrlList: any = [];
  imageUrl = "";
  imageIndex = 1;
  imageSize = 100;
  maxlength = 0;
  pdfUrlList: any = [];
  maxPdflength = 0;
  pdfUrl: string = "";
  pdfIndex = 1;
  created() {
    this.form = Object.assign({}, this.data);
    console.log(this.form);
    if (this.form.imageUrl) {
      this.imageUrlList = this.form.imageUrl.split(";");
      this.maxlength = this.imageUrlList.length;
    }
    if (this.form.pdfList) {
      this.pdfUrlList = this.form.pdfList;
      this.maxPdflength = this.pdfUrlList.length;
      this.pdfUrl = `/pdf/web/viewer.html?file=${encodeURIComponent(
        this.Url + this.pdfUrlList[0].fileUrl
      )}`;
    }
  }
  setPdfUrl() {
    if (this.pdfIndex >= this.maxPdflength) {
      this.pdfIndex = this.maxPdflength;
    }
    if (this.pdfIndex <= 1) {
      this.pdfIndex = 1;
    }
    this.pdfUrl = `/pdf/web/viewer.html?file=${encodeURIComponent(
      this.Url + this.pdfUrlList[this.pdfIndex - 1].fileUrl
    )}`;
  }
  rules = {};
  next() {
    if (this.imageIndex + 1 > this.maxlength) {
      this.imageIndex = 1;
    } else {
      this.imageIndex++;
    }
  }
  previous() {
    if (this.imageIndex <= 1) {
      this.imageIndex = this.maxlength;
    } else {
      this.imageIndex--;
    }
  }
  nextPdf() {
    if (this.pdfIndex + 1 > this.maxPdflength) {
      this.pdfIndex = 1;
    } else {
      this.pdfIndex++;
    }
    this.pdfUrl = `/pdf/web/viewer.html?file=${encodeURIComponent(
      this.Url + this.pdfUrlList[this.pdfIndex - 1].fileUrl
    )}`;
  }
  previousPdf() {
    if (this.pdfIndex <= 1) {
      this.pdfIndex = this.maxPdflength;
    } else {
      this.pdfIndex--;
    }
    this.pdfUrl = `/pdf/web/viewer.html?file=${encodeURIComponent(
      this.Url + this.pdfUrlList[this.pdfIndex - 1].fileUrl
    )}`;
  }
  cancel() {
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  get headers() {
    return {
      "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie(),
      Authorization: "Bearer " + window.abp.auth.getToken(),
      "X-Frame-Options": "SAMEORIGIN",
    };
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pathologyManage/parts/pathologicdiagnosis2/imagePacs.vue